<template>
  <div class="frame-77 clean lang-dir" @click="$emit('click', $event)">
    <div class="frame-3">
      <div class="frame-82">
        <p class="pa-title">
          {{ title }}
        </p>
        <p class="pa-content">
          <slot></slot>
          <!-- {{ content }} -->
        </p>
      </div>
    </div>
    <svg
      class="flip-dir"
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="10"
      viewBox="0 0 5 10"
      fill="none"
      style="fill: rgba(0, 0, 0, 0.3)"
    >
      <path
        d="M1.00591 5.00011L4.87796 0.775952C5.04068 0.598437 5.04068 0.310648 4.87796 0.133133C4.71524 -0.0443827 4.45143 -0.0443827 4.28871 0.133163L0.122055 4.67875C0.0438887 4.76396 0 4.87957 0 5.00011C0 5.12069 0.0439165 5.23629 0.122055 5.32154L4.28871 9.86688C4.37004 9.95564 4.47668 10 4.58332 10C4.68996 10 4.7966 9.95564 4.87796 9.86685C5.04068 9.68933 5.04068 9.40154 4.87796 9.22403L1.00591 5.00011Z"
        fill="black"
        fill-opacity="0.3"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: ["title", "content"],
};
</script>

<style lang="scss" scoped>
.pa-content {
  align-self: stretch;
  color: #7b7b7b;

  /* xs */
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 13.2px */
}
.pa-title {
  align-self: stretch;
  color: #000;

  /* otzar body bold */
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 15.6px */
}
.frame-77:hover {
  background-color: #ececec;
}
.frame-77 {
  display: flex;
  padding: 10px 15px;
  align-items: center;
  gap: 15px;
  align-self: stretch;
  border-bottom: 1px solid #dedede;
  cursor: pointer;
}
.frame-3 {
  display: flex;

  align-items: center;
  gap: 15px;
  flex: 1 0 0;
}
.frame-82 {
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 5px;
  flex: 1 0 0;
}
.clean * {
  margin: 0px;
}
</style>
